// Version : 0.0.1
// Author : NANDHAKUMAR
// LastEdit : NANDHAKUMAR
// Last Add : 'UNSED IMPORTS AND VARIABLES REMOVED'
// Modified Date : 04-08-2025
/* eslint-disable import/no-anonymous-default-export */
import CollectionActionTypes from './collection-approve.types';
import { docodeHexResponse } from '../../../_common/common.utils';

const INITIAL_STATE = {
	// Officer List Centers
	getOfficerListCentersResponse: null,
	getOfficerListCentersArr: [],
	// Officer List Arrear Centers
	getOfficerListArrearCentersResponse: null,
	getOfficerListArrearCentersArr: [],
	// Branch Collection Users List
	getBranchCollectionUsersListResponse: null,
	getBranchCollectionUsersListArr: [],
	// Center List Officer Collections
	getCenterListOfficerCollectionsResponse: null,
	getCenterListOfficerCollectionsArr: [],
	// Branch Today Collection Details
	getBranchTodayCollectionDetailsStatus: null,
	getBranchTodayCollectionDetailsArr: [],
	// Branch Today Demand Move To Arrear
	getBranchTodayDemandMoveToArrearStatus: null,
	getBranchTodayDemandMoveToArrearArr: [],
	// Branch Today Closed Loan List
	getBranchTodayClosedLoanListStatus: null,
	getBranchTodayClosedLoanListArr: [],
	// Center Denomination Collection
	getCenterCollectionDenominationDetailsStatus: null,
	getCenterCollectionDenominationDetailsArr: [],
	// Attendance Officer Collection
	getAttendanceOfficerCollectionStatus: null,
	getAttendanceOfficerCollectionArr: [],
	// Branch Collection Funder Allocate EOD
	getBranchCollectionFunderAllocateEODStatus: null,
	getBranchCollectionFunderAllocateEODArr: [],
	// Branch Today Collection Yet To Approve
	getBranchTodayCollectionYetToApproveStatus: null,
	getBranchTodayCollectionYetToApproveArr: [],
	// Branch Today Collection Yet To Approve
	updateLoanPaidPerMemberCollectionResponse: null,
	updateLoanPaidOverallCollectionResponse: null,
	// Security Check Password Verify
	securityCheckPasswordVerifyResponse: null,
	// Revert Allocate For EOD
	revertAllocateForEodResponse: null,
	// Common Collection Update
	commonCollectionUpdateResponse: null,
	// Update Loan Paid Overall Move To Arrear
	updateLoanPaidOverAllMoveToArrearResponse: null,
	// Branch Collection EOD Check
	updateOverallAccruedInterestAllocateForEODResponse: null,
	// Branch Collection EOD Check
	updateOverallAllocateForEODResponse: null,
	// Branch EOD Exist Check
	checkBranchEODExistForDateResponse: null,
	checkBranchEODExistForDateArr: [],
	// Fetch Gold Loan Collection Approve List
	getGoldLoanCollectionApproveListResponse: null,
	getGoldLoanCollectionApproveListArr: [],
	// Fetch Savings Collection Approve Details
	getSavingsCollectionApproveDetailsResponse: null,
	getSavingsCollectionApproveDetailsArr: [],
	// Update Savings Allocate For EOD
	updateSavingsAllocateForEODResponse: null,
	// Fetch Savings Denomination Details
	getSavingsDenominationDetailsResponse: null,
	getSavingsDenominationDetailsArr: [],
	// Update Gold Loan Collection Approve
	updateGoldLoanCollectionApproveResponse: null,
	// Update Savings Collection Approve
	updateSavingsCollectionApproveResponse: null,
	// Submit Approve Staff Travel Details
	submitApproveStaffTravelDetailsResponse: null,
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** OFFICER LIST CENTERS START *********************** */
		case CollectionActionTypes.GET_OFFICER_LIST_CENTERS_SUCCESS:
			return {
				...state,
				getOfficerListCentersResponse: action.payload,
				getOfficerListCentersArr: docodeHexResponse(
					action.payload,
					'centerListForOfficerKey',
				),
			};

		case CollectionActionTypes.GET_OFFICER_LIST_CENTERS_FAILURE:
			return { ...state, getOfficerListCentersResponse: action.payload };

		case CollectionActionTypes.GET_OFFICER_LIST_CENTERS_RESPONSE_CHANGED:
			return { ...state, getOfficerListCentersResponse: null };
		/** ***************** OFFICER LIST CENTERS END *********************** */

		/** ***************** OFFICER LIST ARREAR CENTERS START *********************** */
		case CollectionActionTypes.GET_OFFICER_LIST_ARREAR_CENTERS_SUCCESS:
			return {
				...state,
				getOfficerListArrearCentersResponse: action.payload,
				getOfficerListArrearCentersArr: docodeHexResponse(
					action.payload,
					'arrearCenterListForOfficerKey',
				),
			};

		case CollectionActionTypes.GET_OFFICER_LIST_ARREAR_CENTERS_FAILURE:
			return { ...state, getOfficerListArrearCentersResponse: action.payload };

		case CollectionActionTypes.GET_OFFICER_LIST_ARREAR_CENTERS_RESPONSE_CHANGED:
			return { ...state, getOfficerListArrearCentersResponse: null };
		/** ***************** OFFICER LIST ARREAR CENTERS END *********************** */

		/** ***************** BRANCH COLLECTION USERS LIST START *********************** */
		case CollectionActionTypes.GET_BRANCH_COLLECTION_USERS_LIST_SUCCESS:
			return {
				...state,
				getBranchCollectionUsersListResponse: action.payload,
				getBranchCollectionUsersListArr: docodeHexResponse(
					action.payload,
					'branchCollectionUsersListKey',
				),
			};

		case CollectionActionTypes.GET_BRANCH_COLLECTION_USERS_LIST_FAILURE:
			return { ...state, getBranchCollectionUsersListResponse: action.payload };

		case CollectionActionTypes.GET_BRANCH_COLLECTION_USERS_LIST_RESPONSE_CHANGED:
			return { ...state, getBranchCollectionUsersListResponse: null };
		/** ***************** BRANCH COLLECTION USERS LIST END *********************** */

		/** ***************** CENTER LIST OFFICER COLLECTIONS START *********************** */
		case CollectionActionTypes.GET_CENTER_LIST_OFFICER_COLLECTIONS_SUCCESS:
			return {
				...state,
				getCenterListOfficerCollectionsResponse: action.payload,
				getCenterListOfficerCollectionsArr: docodeHexResponse(
					action.payload,
					'centerListOfficerCollectionsKey',
				),
			};

		case CollectionActionTypes.GET_CENTER_LIST_OFFICER_COLLECTIONS_FAILURE:
			return { ...state, getCenterListOfficerCollectionsResponse: action.payload };

		case CollectionActionTypes.GET_CENTER_LIST_OFFICER_COLLECTIONS_RESPONSE_CHANGED:
			return { ...state, getCenterListOfficerCollectionsResponse: null };
		/** ***************** CENTER LIST OFFICER COLLECTIONS END *********************** */

		/** ***************** BRANCH TODAY COLLECTION DETAILS START *********************** */
		// BRANCH TODAY COLLECTION SECTION
		case CollectionActionTypes.GET_BRANCH_TODAY_COLLECTION_DETAILS_SUCCESS:
			return {
				...state,
				getBranchTodayCollectionDetailsStatus: action.payload,
				getBranchTodayCollectionDetailsArr: docodeHexResponse(
					action.payload,
					'FetchBranchTodayCollectionDetailsKey',
				),
			};

		case CollectionActionTypes.GET_BRANCH_TODAY_COLLECTION_DETAILS_FAILURE:
			return { ...state, getBranchTodayCollectionDetailsStatus: action.payload };

		case CollectionActionTypes.GET_BRANCH_TODAY_COLLECTION_DETAILS_CHANGED:
			return { ...state, getBranchTodayCollectionDetailsStatus: null };
		/** ***************** BRANCH TODAY COLLECTION DETAILS END *********************** */

		/** ***************** BRANCH TODAY DEMAND MOVE TO ARREAR START *********************** */
		case CollectionActionTypes.GET_BRANCH_TODAY_DEMAND_MOVETOARREAR_LIST_SUCCESS:
			return {
				...state,
				getBranchTodayDemandMoveToArrearStatus: action.payload,
				getBranchTodayDemandMoveToArrearArr: docodeHexResponse(
					action.payload,
					'FetchBranchTodayDemandMoveToArrearListKey',
				),
			};

		case CollectionActionTypes.GET_BRANCH_TODAY_DEMAND_MOVETOARREAR_LIST_FAILURE:
			return { ...state, getBranchTodayDemandMoveToArrearStatus: action.payload };

		case CollectionActionTypes.GET_BRANCH_TODAY_DEMAND_MOVETOARREAR_LIST_CHANGED:
			return { ...state, getBranchTodayDemandMoveToArrearStatus: null };
		/** ***************** BRANCH TODAY DEMAND MOVE TO ARREAR END *********************** */

		/** ***************** BRANCH TODAY CLOSED LOAN LIST FETCH START *********************** */
		// BRANCH TODAY CLOSED LOAN LIST FETCH
		case CollectionActionTypes.GET_BRANCH_CLOSED_LOAN_LIST_SUCCESS:
			return {
				...state,
				getBranchTodayClosedLoanListStatus: action.payload,
				getBranchTodayClosedLoanListArr: docodeHexResponse(
					action.payload,
					'CloseLoanListFetchKey',
				),
			};

		case CollectionActionTypes.GET_BRANCH_CLOSED_LOAN_LIST_FAILURE:
			return { ...state, getBranchTodayClosedLoanListStatus: action.payload };

		case CollectionActionTypes.GET_BRANCH_CLOSED_LOAN_LIST_CHANGED:
			return { ...state, getBranchTodayClosedLoanListStatus: null };
		/** ***************** BRANCH TODAY CLOSED LOAN LIST FETCH END *********************** */

		/** ***************** CENTER DENOMINATION COLLECTION START *********************** */
		// CENTER DENOMINATION COLLECTION SECTION
		case CollectionActionTypes.GET_CENTER_COLLECTION_DENOMINATION_DETAILS_SUCCESS:
			return {
				...state,
				getCenterCollectionDenominationDetailsStatus: action.payload,
				getCenterCollectionDenominationDetailsArr: docodeHexResponse(
					action.payload,
					'FetchCenterCollectionDenominationKey',
				),
			};

		case CollectionActionTypes.GET_CENTER_COLLECTION_DENOMINATION_DETAILS_FAILURE:
			return { ...state, getCenterCollectionDenominationDetailsStatus: action.payload };

		case CollectionActionTypes.GET_CENTER_COLLECTION_DENOMINATION_DETAILS_CHANGED:
			return { ...state, getCenterCollectionDenominationDetailsStatus: null };
		/** ***************** CENTER DENOMINATION COLLECTION END *********************** */

		/** ***************** ATTENDANCE OFFICER COLLECTION START *********************** */
		case CollectionActionTypes.GET_ATTENDANCE_OFFICER_COLLECTION_SUCCESS:
			return {
				...state,
				getAttendanceOfficerCollectionStatus: action.payload,
				getAttendanceOfficerCollectionArr: docodeHexResponse(
					action.payload,
					'FetchAttendanceBasedOfficerCollectionKey',
				),
			};

		case CollectionActionTypes.GET_ATTENDANCE_OFFICER_COLLECTION_FAILURE:
			return { ...state, getAttendanceOfficerCollectionStatus: action.payload };

		case CollectionActionTypes.GET_ATTENDANCE_OFFICER_COLLECTION_CHANGED:
			return { ...state, getAttendanceOfficerCollectionStatus: null };
		/** ***************** ATTENDANCE OFFICER COLLECTION END *********************** */

		/** ***************** BRANCH COLLECTION FUNDER ALLOCATE EOD START *********************** */
		case CollectionActionTypes.GET_BRANCH_COLLECTION_FUNDER_ALLOCATE_EOD_SUCCESS:
			return {
				...state,
				getBranchCollectionFunderAllocateEODStatus: action.payload,
				getBranchCollectionFunderAllocateEODArr: docodeHexResponse(
					action.payload,
					'BranchCollectionsAllocateForEodKey',
				),
			};

		case CollectionActionTypes.GET_BRANCH_COLLECTION_FUNDER_ALLOCATE_EOD_FAILURE:
			return { ...state, getBranchCollectionFunderAllocateEODStatus: action.payload };

		case CollectionActionTypes.GET_BRANCH_COLLECTION_FUNDER_ALLOCATE_EOD_CHANGED:
			return { ...state, getBranchCollectionFunderAllocateEODStatus: null };

		case CollectionActionTypes.GET_BRANCH_COLLECTION_FUNDER_ALLOCATE_EOD_CHANGED_DATA:
			return { ...state, getBranchCollectionFunderAllocateEODArr: [] };

		/** ***************** BRANCH COLLECTION FUNDER ALLOCATE EOD END *********************** */

		/** ***************** BRANCH TODAY COLLECTION YET TO APPROVE START *********************** */
		case CollectionActionTypes.GET_BRANCH_TODAY_COLLECTION_YET_TO_APPROVE_SUCCESS:
			return {
				...state,
				getBranchTodayCollectionYetToApproveStatus: action.payload,
				getBranchTodayCollectionYetToApproveArr: docodeHexResponse(
					action.payload,
					'BranchCollectionsAllocateForEodKey',
				),
			};

		case CollectionActionTypes.GET_BRANCH_TODAY_COLLECTION_YET_TO_APPROVE_FAILURE:
			return { ...state, getBranchTodayCollectionYetToApproveStatus: action.payload };

		case CollectionActionTypes.GET_BRANCH_TODAY_COLLECTION_YET_TO_APPROVE_CHANGED:
			return { ...state, getBranchTodayCollectionYetToApproveStatus: null };

		case CollectionActionTypes.GET_BRANCH_TODAY_COLLECTION_YET_TO_APPROVE_CHANGED_DATA:
			return {
				...state,
				getBranchTodayCollectionYetToApproveArr: [],
			};
		/** ***************** BRANCH TODAY COLLECTION YET TO APPROVE END *********************** */

		/** ***************** UPDATE LOAN PAID PER MEMBER COLLECTION APPROVE START *********************** */
		case CollectionActionTypes.UPDATE_LOANPAID_PER_MEMBER_COLLECTION_APPROVE_SUCCESS:
			return {
				...state,
				updateLoanPaidPerMemberCollectionResponse: action.payload,
			};

		case CollectionActionTypes.UPDATE_LOANPAID_PER_MEMBER_COLLECTION_APPROVE_FAILURE:
			return { ...state, updateLoanPaidPerMemberCollectionResponse: action.payload };

		case CollectionActionTypes.UPDATE_LOANPAID_PER_MEMBER_COLLECTION_APPROVE_CHANGED:
			return { ...state, updateLoanPaidPerMemberCollectionResponse: null };

		case CollectionActionTypes.UPDATE_LOANPAID_OVERALL_COLLECTION_APPROVE_SUCCESS:
			return {
				...state,
				updateLoanPaidOverallCollectionResponse: action.payload,
			};

		case CollectionActionTypes.UPDATE_LOANPAID_OVERALL_COLLECTION_APPROVE_FAILURE:
			return { ...state, updateLoanPaidOverallCollectionResponse: action.payload };

		case CollectionActionTypes.UPDATE_LOANPAID_OVERALL_COLLECTION_APPROVE_CHANGED:
			return { ...state, updateLoanPaidOverallCollectionResponse: null };
		/** ***************** UPDATE LOAN PAID PER MEMBER COLLECTION APPROVE END *********************** */

		/** ***************** SECURITY CHECK PASSWORD VERIFY START *********************** */
		case CollectionActionTypes.SECURITY_CHECK_PASSWORD_VERIFY_SUCCESS:
			return {
				...state,
				securityCheckPasswordVerifyResponse: action.payload,
			};

		case CollectionActionTypes.SECURITY_CHECK_PASSWORD_VERIFY_FAILURE:
			return { ...state, securityCheckPasswordVerifyResponse: action.payload };

		case CollectionActionTypes.SECURITY_CHECK_PASSWORD_VERIFY_CHANGED:
			return { ...state, securityCheckPasswordVerifyResponse: null };
		/** ***************** SECURITY CHECK PASSWORD VERIFY END *********************** */

		/** ***************** REVERT ALLOCATE FOR EOD START *********************** */
		case CollectionActionTypes.REVERT_ALLOCATE_FOR_EOD_SUCCESS:
			return {
				...state,
				revertAllocateForEodResponse: action.payload,
			};

		case CollectionActionTypes.REVERT_ALLOCATE_FOR_EOD_FAILURE:
			return { ...state, revertAllocateForEodResponse: action.payload };

		case CollectionActionTypes.REVERT_ALLOCATE_FOR_EOD_CHANGED:
			return { ...state, revertAllocateForEodResponse: null };
		/** ***************** REVERT ALLOCATE FOR EOD END *********************** */

		/** ***************** COMMON COLLECTION UPDATE START *********************** */
		case CollectionActionTypes.COMMON_COLLECTION_UPDATE_SUCCESS:
			return {
				...state,
				commonCollectionUpdateResponse: action.payload,
			};

		case CollectionActionTypes.COMMON_COLLECTION_UPDATE_FAILURE:
			return { ...state, commonCollectionUpdateResponse: action.payload };

		case CollectionActionTypes.COMMON_COLLECTION_UPDATE_CHANGED:
			return { ...state, commonCollectionUpdateResponse: null };
		/** ***************** COMMON COLLECTION UPDATE END *********************** */

		/** ***************** UPDATE LOAN PAID OVERALL MOVE TO ARREAR START *********************** */
		case CollectionActionTypes.UPDATE_LOANPAID_OVERALL_MOVE_TO_ARREAR_SUCCESS:
			return {
				...state,
				updateLoanPaidOverAllMoveToArrearResponse: action.payload,
			};

		/** ***************** UPDATE LOAN PAID OVERALL MOVE TO ARREAR END *********************** */

		/** ***************** CHECK BRANCH EOD EXIST START *********************** */
		case CollectionActionTypes.CHECK_BRANCH_EOD_EXIST_SUCCESS:
			return {
				...state,
				checkBranchEODExistResponse: action.payload,
				checkBranchEODExistArr: docodeHexResponse(action.payload, 'checkBranchEODExistKey'),
			};

		case CollectionActionTypes.CHECK_BRANCH_EOD_EXIST_FAILURE:
			return { ...state, checkBranchEODExistResponse: action.payload };

		case CollectionActionTypes.CHECK_BRANCH_EOD_EXIST_CHANGED:
			return { ...state, checkBranchEODExistResponse: null };

		/** ***************** CHECK BRANCH EOD EXIST END *********************** */

		/** ***************** CHECK BRANCH EOD EXIST FOR DATE START *********************** */
		case CollectionActionTypes.CHECK_BRANCH_EOD_EXIST_FOR_DATE_SUCCESS:
			return {
				...state,
				checkBranchEODExistForDateResponse: action.payload,
				checkBranchEODExistForDateArr: docodeHexResponse(
					action.payload,
					'CheckEODDoneForBranchDateKey',
				),
			};

		case CollectionActionTypes.CHECK_BRANCH_EOD_EXIST_FOR_DATE_FAILURE:
			return { ...state, checkBranchEODExistForDateResponse: action.payload };

		case CollectionActionTypes.CHECK_BRANCH_EOD_EXIST_FOR_DATE_CHANGED:
			return { ...state, checkBranchEODExistForDateResponse: null };

		/** ***************** CHECK BRANCH EOD EXIST FOR DATE END *********************** */

		/** ***************** UPDATE LOAN PAID OVERALL MOVE TO ARREAR START *********************** */
		case CollectionActionTypes.UPDATE_LOANPAID_OVERALL_MOVE_TO_ARREAR_FAILURE:
			return { ...state, updateLoanPaidOverAllMoveToArrearResponse: action.payload };

		case CollectionActionTypes.UPDATE_LOANPAID_OVERALL_MOVE_TO_ARREAR_CHANGED:
			return { ...state, updateLoanPaidOverAllMoveToArrearResponse: null };

		/** ***************** UPDATE LOAN PAID OVERALL MOVE TO ARREAR END *********************** */

		/** ***************** UPDATE OVERALL ACCRUED INTEREST ALLOCATE FOR EOD START *********************** */
		case CollectionActionTypes.UPDATE_OVERALL_ACCRUED_INTEREST_ALLOCATE_FOR_EOD_SUCCESS:
			return {
				...state,
				updateOverallAccruedInterestAllocateForEODResponse: action.payload,
			};

		case CollectionActionTypes.UPDATE_OVERALL_ACCRUED_INTEREST_ALLOCATE_FOR_EOD_FAILURE:
			return { ...state, updateOverallAccruedInterestAllocateForEODResponse: action.payload };

		case CollectionActionTypes.UPDATE_OVERALL_ACCRUED_INTEREST_ALLOCATE_FOR_EOD_CHANGED:
			return { ...state, updateOverallAccruedInterestAllocateForEODResponse: null };

		/** ***************** UPDATE OVERALL ACCRUED INTEREST ALLOCATE FOR EOD END *********************** */

		/** ***************** UPDATE OVERALL ALLOCATE FOR EOD START *********************** */
		case CollectionActionTypes.UPDATE_OVERALL_ALLOCATE_FOR_EOD_SUCCESS:
			return {
				...state,
				updateOverallAllocateForEODResponse: action.payload,
			};

		case CollectionActionTypes.UPDATE_OVERALL_ALLOCATE_FOR_EOD_FAILURE:
			return { ...state, updateOverallAllocateForEODResponse: action.payload };

		case CollectionActionTypes.UPDATE_OVERALL_ALLOCATE_FOR_EOD_CHANGED:
			return { ...state, updateOverallAllocateForEODResponse: null };

		/** ***************** UPDATE OVERALL ALLOCATE FOR EOD END *********************** */

		/** ***************** FETCH GOLD LOAN COLLECTION APPROVE LIST START *********************** */

		case CollectionActionTypes.FETCH_GOLD_LOAN_COLLECTION_APPROVE_LIST_SUCCESS:
			return {
				...state,
				getGoldLoanCollectionApproveListResponse: action.payload,
				getGoldLoanCollectionApproveListArr: docodeHexResponse(
					action.payload,
					'GoldCollectionMembersForApproveKey',
				),
			};

		case CollectionActionTypes.FETCH_GOLD_LOAN_COLLECTION_APPROVE_LIST_RESPONSE_CHANGED:
			return {
				...state,
				getGoldLoanCollectionApproveListResponse: null,
			};

		case CollectionActionTypes.FETCH_GOLD_LOAN_COLLECTION_APPROVE_LIST_FAILURE:
			return { ...state, getGoldLoanCollectionApproveListResponse: action.payload };

		/** ***************** FETCH GOLD LOAN COLLECTION APPROVE LIST END *********************** */

		/** ***************** FETCH SAVINGS COLLECTION APPROVE DETAILS START *********************** */

		case CollectionActionTypes.FETCH_SAVINGS_COLLECTION_APPROVE_DETAILS_SUCCESS:
			return {
				...state,
				getSavingsCollectionApproveDetailsResponse: action.payload,
				getSavingsCollectionApproveDetailsArr: docodeHexResponse(
					action.payload,
					'SavingsCollectionMembersForApproveKey',
				),
			};

		case CollectionActionTypes.FETCH_SAVINGS_COLLECTION_APPROVE_DETAILS_RESPONSE_CHANGED:
			return {
				...state,
				getSavingsCollectionApproveDetailsResponse: null,
			};

		case CollectionActionTypes.FETCH_SAVINGS_COLLECTION_APPROVE_DETAILS_FAILURE:
			return { ...state, getSavingsCollectionApproveDetailsResponse: action.payload };

		/** ***************** FETCH SAVINGS COLLECTION APPROVE DETAILS END *********************** */

		/** ***************** UPDATE SAVINGS ALLOCATE FOR EOD START *********************** */
		case CollectionActionTypes.UPDATE_SAVINGS_ALLOCATE_FOR_EOD_SUCCESS:
			return {
				...state,
				updateSavingsAllocateForEODResponse: action.payload,
			};

		case CollectionActionTypes.UPDATE_SAVINGS_ALLOCATE_FOR_EOD_FAILURE:
			return { ...state, updateSavingsAllocateForEODResponse: action.payload };

		case CollectionActionTypes.UPDATE_SAVINGS_ALLOCATE_FOR_EOD_CHANGED:
			return { ...state, updateSavingsAllocateForEODResponse: null };

		/** ***************** UPDATE SAVINGS ALLOCATE FOR EOD END *********************** */

		/** ***************** FETCH SAVINGS DENOMINATION DETAILS START *********************** */

		case CollectionActionTypes.GET_SAVINGS_DENOMINATION_DETAILS_SUCCESS:
			return {
				...state,
				getSavingsDenominationDetailsResponse: action.payload,
				getSavingsDenominationDetailsArr: docodeHexResponse(
					action.payload,
					'GetSavingsDenominationKey',
				),
			};

		case CollectionActionTypes.GET_SAVINGS_DENOMINATION_DETAILS_FAILURE:
			return { ...state, getSavingsDenominationDetailsResponse: action.payload };

		case CollectionActionTypes.GET_SAVINGS_DENOMINATION_DETAILS_RESPONSE_CHANGED:
			return { ...state, getSavingsDenominationDetailsResponse: null };

		/** ***************** FETCH SAVINGS DENOMINATION DETAILS END *********************** */

		/** ***************** UPDATE GOLD LOAN COLLECTION APPROVE START *********************** */
		case CollectionActionTypes.UPDATE_GOLD_LOAN_COLLECTION_APPROVE_SUCCESS:
			return {
				...state,
				updateGoldLoanCollectionApproveResponse: action.payload,
			};

		case CollectionActionTypes.UPDATE_GOLD_LOAN_COLLECTION_APPROVE_FAILURE:
			return { ...state, updateGoldLoanCollectionApproveResponse: action.payload };

		case CollectionActionTypes.UPDATE_GOLD_LOAN_COLLECTION_APPROVE_RESPONSE_CHANGED:
			return { ...state, updateGoldLoanCollectionApproveResponse: null };

		/** ***************** UPDATE GOLD LOAN COLLECTION APPROVE END *********************** */

		/** ***************** UPDATE SAVINGS COLLECTION APPROVE START *********************** */
		case CollectionActionTypes.UPDATE_SAVINGS_COLLECTION_APPROVE_SUCCESS:
			return {
				...state,
				updateSavingsCollectionApproveResponse: action.payload,
			};

		case CollectionActionTypes.UPDATE_SAVINGS_COLLECTION_APPROVE_FAILURE:
			return { ...state, updateSavingsCollectionApproveResponse: action.payload };

		case CollectionActionTypes.UPDATE_SAVINGS_COLLECTION_APPROVE_RESPONSE_CHANGED:
			return { ...state, updateSavingsCollectionApproveResponse: null };
		/** ***************** UPDATE SAVINGS COLLECTION APPROVE END *********************** */
		/** ***************** SUBMIT APPROVE STAFF TRAVEL DETAILS START *********************** */
		case CollectionActionTypes.SUBMIT_APPROVE_STAFF_TRAVEL_DETAILS_SUCCESS:
			return {
				...state,
				submitApproveStaffTravelDetailsResponse: action.payload,
			};

		case CollectionActionTypes.SUBMIT_APPROVE_STAFF_TRAVEL_DETAILS_FAILURE:
			return { ...state, submitApproveStaffTravelDetailsResponse: action.payload };

		case CollectionActionTypes.SUBMIT_APPROVE_STAFF_TRAVEL_DETAILS_RESPONSE_CHANGED:
			return { ...state, submitApproveStaffTravelDetailsResponse: null };
		/** ***************** SUBMIT APPROVE STAFF TRAVEL DETAILS END *********************** */

		default:
			return state;
	}
};
